import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 32 32"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M.837 8H31.19c.645 2.723.84 5.507.808 8H.003v-.017C-.028 13.528.197 10.751.838 8",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "M.003 16h31.994v.016c.032 2.456-.193 5.233-.834 7.984H.836c-.67-2.744-.864-5.516-.833-8",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#227FBB",
      fillRule: "evenodd",
      d: "M.835 24h30.327l-.029.124s-1.028 4.918-5.476 6.646C23.567 31.6 19.75 31.966 16 32c-3.75-.034-7.567-.432-9.658-1.23C1.895 29.042.866 24.124.866 24.124z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#F2C500",
      fillRule: "evenodd",
      d: "M31.189 8H.837l.03-.125S1.894 2.957 6.341 1.23C8.433.432 12.25.033 16 0c3.75.033 7.567.432 9.69 1.263 4.448 1.728 5.477 6.646 5.477 6.646z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#1AAF5D",
      fillRule: "evenodd",
      d: "M3.307 3.307 16 16 3.308 28.692C1.39 26.63.866 24.124.866 24.124c-.697-2.79-.896-5.615-.863-8.14-.033-2.493.2-5.317.863-8.109 0 0 .524-2.505 2.441-4.568",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M7 20.874q-.53.125-1.099.126C3.194 21 1 18.761 1 16s2.194-5 4.901-5q.568.002 1.099.126c-2.178.509-3.803 2.498-3.803 4.874S4.822 20.365 7 20.874c-2.178-.509 0 0 0 0",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "m7 12.733-.588.41.207-.686-.57-.433.716-.014.235-.677.235.677.716.014-.57.433.207.685zm0 2.445-.588.409.207-.686-.57-.432.716-.015.235-.676.235.676.716.015-.57.432.207.686zm0 2.444-.588.41.207-.686-.57-.433.716-.014.235-.677.235.677.716.014-.57.433.207.685zm0 2.445-.588.409.207-.686-.57-.432.716-.015.235-.676.235.676.716.015-.57.432.207.686z",
      clipRule: "evenodd"
    }
  )
);
var SvgFlagCom = styled(SvgComponent)`
  ${size}
  ${color}
`;
var FlagCom_default = SvgFlagCom;

export { FlagCom_default as default };
